// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.phone-selector {
  width: 120px;
  height: 24px;
  border-radius: 5px;
  border: solid 1px #ced4d9;
}

.phone {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  align-items: center;
  width: 100%;
  min-width: 0;
  max-width: 300px;
}

.country {
  flex: 0 1 8rem;
  min-width: 8rem;
}

.phone-number {
  flex: 1 1 8rem;
  min-width: 0;
}

.input-phone {
  width: 100%;
}

.row-item-country {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  min-width: 200px;
}
.row-item-country img {
  height: 1.3em;
}

.row-item-separator {
  border: 0;
  border-top: 1px solid #bdbdbd;
  margin: 3px 0;
  width: 100%;
  height: 0;
  display: block;
  opacity: 1;
  pointer-events: none;
}

.text-under-input {
  margin-top: 10px;
}
.text-under-input.dynamic {
  display: flex;
}
.text-under-input.dynamic .number {
  display: flex;
}
.text-under-input.dynamic .number .space {
  width: 5px;
}

:host ::ng-deep .ui-fluid p-autocomplete,
:host .ui-fluid .ui-autocomplete,
:host .ui-fluid .ui-autocomplete-input {
  display: flex !important;
}

:host ::ng-deep .ui-fluid p-autocomplete,
:host .ui-fluid .ui-autocomplete,
:host .ui-fluid .ui-autocomplete-input {
  height: 40px !important;
}
:host ::ng-deep .ui-fluid p-autocomplete span input,
:host .ui-fluid .ui-autocomplete span input,
:host .ui-fluid .ui-autocomplete-input span input {
  height: 40px !important;
}
/*# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbInBob25lLWVkaXRvci5jb21wb25lbnQuc2NzcyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFBQTtFQUNJLFlBQUE7RUFDQSxZQUFBO0VBQ0Esa0JBQUE7RUFDQSx5QkFBQTtBQUNKOztBQUVBO0VBQ0ksYUFBQTtFQUNBLGVBQUE7RUFDQSxTQUFBO0VBQ0EsbUJBQUE7RUFDQSxXQUFBO0VBQ0EsWUFBQTtFQUNBLGdCQUFBO0FBQ0o7O0FBRUE7RUFDSSxjQUFBO0VBQ0EsZUFBQTtBQUNKOztBQUVBO0VBQ0ksY0FBQTtFQUNBLFlBQUE7QUFDSjs7QUFFQTtFQUNJLFdBQUE7QUFDSjs7QUFDQTtFQUNJLGFBQUE7RUFDQSxtQkFBQTtFQUNBLG1CQUFBO0VBQ0EsOEJBQUE7RUFDQSxnQkFBQTtBQUVKO0FBREk7RUFDSSxhQUFBO0FBR1I7O0FBQ0E7RUFDSSxTQUFBO0VBQ0EsNkJBQUE7RUFDQSxhQUFBO0VBQ0EsV0FBQTtFQUNBLFNBQUE7RUFDQSxjQUFBO0VBQ0EsVUFBQTtFQUNBLG9CQUFBO0FBRUo7O0FBQ0E7RUFDSSxnQkFBQTtBQUVKO0FBQUk7RUFDSSxhQUFBO0FBRVI7QUFBUTtFQUNJLGFBQUE7QUFFWjtBQUFZO0VBQ0ksVUFBQTtBQUVoQjs7QUFLSTs7O0VBR0ksd0JBQUE7QUFGUjs7QUFPSTs7O0VBR0ksdUJBQUE7QUFKUjtBQU1ZOzs7RUFDSSx1QkFBQTtBQUZoQiIsImZpbGUiOiJwaG9uZS1lZGl0b3IuY29tcG9uZW50LnNjc3MiLCJzb3VyY2VzQ29udGVudCI6WyIucGhvbmUtc2VsZWN0b3Ige1xuICAgIHdpZHRoOiAxMjBweDtcbiAgICBoZWlnaHQ6IDI0cHg7XG4gICAgYm9yZGVyLXJhZGl1czogNXB4O1xuICAgIGJvcmRlcjogc29saWQgMXB4ICNjZWQ0ZDk7XG59XG5cbi5waG9uZSB7XG4gICAgZGlzcGxheTogZmxleDtcbiAgICBmbGV4LXdyYXA6IHdyYXA7XG4gICAgZ2FwOiAxMHB4O1xuICAgIGFsaWduLWl0ZW1zOiBjZW50ZXI7XG4gICAgd2lkdGg6IDEwMCU7XG4gICAgbWluLXdpZHRoOiAwO1xuICAgIG1heC13aWR0aDogMzAwcHg7XG59XG5cbi5jb3VudHJ5IHtcbiAgICBmbGV4OiAwIDEgOHJlbTtcbiAgICBtaW4td2lkdGg6IDhyZW07XG59XG5cbi5waG9uZS1udW1iZXIge1xuICAgIGZsZXg6IDEgMSA4cmVtO1xuICAgIG1pbi13aWR0aDogMDtcbn1cblxuLmlucHV0LXBob25lIHtcbiAgICB3aWR0aDogMTAwJTtcbn1cbi5yb3ctaXRlbS1jb3VudHJ5IHtcbiAgICBkaXNwbGF5OiBmbGV4O1xuICAgIGZsZXgtZGlyZWN0aW9uOiByb3c7XG4gICAgYWxpZ24taXRlbXM6IGNlbnRlcjtcbiAgICBqdXN0aWZ5LWNvbnRlbnQ6IHNwYWNlLWJldHdlZW47XG4gICAgbWluLXdpZHRoOiAyMDBweDtcbiAgICBpbWd7XG4gICAgICAgIGhlaWdodDogMS4zZW07XG4gICAgfVxufVxuXG4ucm93LWl0ZW0tc2VwYXJhdG9yIHtcbiAgICBib3JkZXI6IDA7XG4gICAgYm9yZGVyLXRvcDogMXB4IHNvbGlkICNiZGJkYmQ7XG4gICAgbWFyZ2luOiAzcHggMDtcbiAgICB3aWR0aDogMTAwJTtcbiAgICBoZWlnaHQ6IDA7XG4gICAgZGlzcGxheTogYmxvY2s7XG4gICAgb3BhY2l0eTogMTtcbiAgICBwb2ludGVyLWV2ZW50czogbm9uZTtcbn1cblxuLnRleHQtdW5kZXItaW5wdXQge1xuICAgIG1hcmdpbi10b3A6IDEwcHg7XG5cbiAgICAmLmR5bmFtaWMge1xuICAgICAgICBkaXNwbGF5OiBmbGV4O1xuXG4gICAgICAgIC5udW1iZXIge1xuICAgICAgICAgICAgZGlzcGxheTogZmxleDtcblxuICAgICAgICAgICAgLnNwYWNlIHtcbiAgICAgICAgICAgICAgICB3aWR0aDogNXB4O1xuICAgICAgICAgICAgfVxuICAgICAgICB9XG4gICAgfVxufVxuXG46aG9zdCB7XG4gICAgOjpuZy1kZWVwIC51aS1mbHVpZCBwLWF1dG9jb21wbGV0ZSxcbiAgICAudWktZmx1aWQgLnVpLWF1dG9jb21wbGV0ZSxcbiAgICAudWktZmx1aWQgLnVpLWF1dG9jb21wbGV0ZS1pbnB1dCB7XG4gICAgICAgIGRpc3BsYXk6IGZsZXggIWltcG9ydGFudDtcbiAgICB9XG59XG5cbjpob3N0IHtcbiAgICA6Om5nLWRlZXAgLnVpLWZsdWlkIHAtYXV0b2NvbXBsZXRlLFxuICAgIC51aS1mbHVpZCAudWktYXV0b2NvbXBsZXRlLFxuICAgIC51aS1mbHVpZCAudWktYXV0b2NvbXBsZXRlLWlucHV0IHtcbiAgICAgICAgaGVpZ2h0OiA0MHB4ICFpbXBvcnRhbnQ7XG4gICAgICAgIHNwYW4ge1xuICAgICAgICAgICAgaW5wdXQge1xuICAgICAgICAgICAgICAgIGhlaWdodDogNDBweCAhaW1wb3J0YW50O1xuICAgICAgICAgICAgfVxuICAgICAgICB9XG4gICAgfVxufVxuIl19 */`, "",{"version":3,"sources":["webpack://./projects/app-ui/src/app/admin/components/field/field-editor/phone-editor/phone-editor.component.scss"],"names":[],"mappings":"AAAA;EACI,YAAA;EACA,YAAA;EACA,kBAAA;EACA,yBAAA;AACJ;;AAEA;EACI,aAAA;EACA,eAAA;EACA,SAAA;EACA,mBAAA;EACA,WAAA;EACA,YAAA;EACA,gBAAA;AACJ;;AAEA;EACI,cAAA;EACA,eAAA;AACJ;;AAEA;EACI,cAAA;EACA,YAAA;AACJ;;AAEA;EACI,WAAA;AACJ;;AACA;EACI,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,8BAAA;EACA,gBAAA;AAEJ;AADI;EACI,aAAA;AAGR;;AACA;EACI,SAAA;EACA,6BAAA;EACA,aAAA;EACA,WAAA;EACA,SAAA;EACA,cAAA;EACA,UAAA;EACA,oBAAA;AAEJ;;AACA;EACI,gBAAA;AAEJ;AAAI;EACI,aAAA;AAER;AAAQ;EACI,aAAA;AAEZ;AAAY;EACI,UAAA;AAEhB;;AAKI;;;EAGI,wBAAA;AAFR;;AAOI;;;EAGI,uBAAA;AAJR;AAMY;;;EACI,uBAAA;AAFhB;AACA,g6FAAg6F","sourcesContent":[".phone-selector {\n    width: 120px;\n    height: 24px;\n    border-radius: 5px;\n    border: solid 1px #ced4d9;\n}\n\n.phone {\n    display: flex;\n    flex-wrap: wrap;\n    gap: 10px;\n    align-items: center;\n    width: 100%;\n    min-width: 0;\n    max-width: 300px;\n}\n\n.country {\n    flex: 0 1 8rem;\n    min-width: 8rem;\n}\n\n.phone-number {\n    flex: 1 1 8rem;\n    min-width: 0;\n}\n\n.input-phone {\n    width: 100%;\n}\n.row-item-country {\n    display: flex;\n    flex-direction: row;\n    align-items: center;\n    justify-content: space-between;\n    min-width: 200px;\n    img{\n        height: 1.3em;\n    }\n}\n\n.row-item-separator {\n    border: 0;\n    border-top: 1px solid #bdbdbd;\n    margin: 3px 0;\n    width: 100%;\n    height: 0;\n    display: block;\n    opacity: 1;\n    pointer-events: none;\n}\n\n.text-under-input {\n    margin-top: 10px;\n\n    &.dynamic {\n        display: flex;\n\n        .number {\n            display: flex;\n\n            .space {\n                width: 5px;\n            }\n        }\n    }\n}\n\n:host {\n    ::ng-deep .ui-fluid p-autocomplete,\n    .ui-fluid .ui-autocomplete,\n    .ui-fluid .ui-autocomplete-input {\n        display: flex !important;\n    }\n}\n\n:host {\n    ::ng-deep .ui-fluid p-autocomplete,\n    .ui-fluid .ui-autocomplete,\n    .ui-fluid .ui-autocomplete-input {\n        height: 40px !important;\n        span {\n            input {\n                height: 40px !important;\n            }\n        }\n    }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
